import { inject, Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, timeout } from 'rxjs/operators';

import { FEATURE_FLAG_SERVICE, FeatureFlagKey } from '@sondermind/data-access/feature-flags';

/**
 * Route guard that enables the one-page checkout route only when
 * the feature flag is ON. Falls back to false on timeout (1s)
 * to avoid blocking navigation. Always returns false for internal users.
 */
@Injectable({ providedIn: 'root' })
export class OnePageCheckoutFeatureFlagGuard implements CanMatch {
  private featureFlagService = inject(FEATURE_FLAG_SERVICE);
  private router = inject(Router);

  canMatch(_route: Route, _segments: UrlSegment[]): Observable<boolean> {
    const queryParams = this.router.getCurrentNavigation()?.extractedUrl.queryParams ?? {};
    if (queryParams['internal'] === 'true') {
      return of(false);
    }

    return this.featureFlagService
      .isEnabled$(FeatureFlagKey.ONE_PAGE_CHECKOUT)
      .pipe(
        take(1),
        timeout({ first: 1000, with: () => of(false) }),
        map(Boolean),
      );
  }
}
